import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ReactToPrint from "react-to-print";

import { getContent } from "../redux/selectors";
import TinyEditor from "../../components/Editor";
import { downloadPDFThunk, SaveQuestionPaperThunk } from "../redux/thunk";
import { handleEditorContent, resetData } from "../redux/editorSlice";
import { handleSelectedTab, handleStage, handleSubmit } from "../redux/slice";
import { selectLoader } from "./others";
import axios from "axios";
import { motion } from "framer-motion";
import Popup from "../../../EventOrganiser/Popup";

function Confirmation({ goToStepByTarget }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const contentToPrintRef = useRef();
  const editorcontentToPrintRef = useRef();
  const dropdownRef = useRef();

  const viewType = location.state?.type || null;

  const { selectedTab, loader } = useSelector((store) => store.createQstnPaper);
  const { content: editorContent } = useSelector(
    (store) => store.createPaperEditor,
  );
  const { isRegistered } = useSelector((state) => state.register);
  const { user: userData } = useSelector((store) => store.authSlice);
  // const { target: joyrideTarget } = useSelector((state) => state.joyride);
  const [showPopup, setShowPopup] = useState(false);
  const content = useSelector(getContent);

  const isDemoUser = userData?.admin_id === 104;

  const blockDemoUser = () => {
    setShowPopup(true);
    return true;
  };

  //   const handleSubmitbtn = async (type) => {
  //     if (isDemoUser) return blockDemoUser();
  //     if (type === 1) {
  //       if (userData.admin_id === 104) {
  //         return alert(
  //           "You are currently using the demo experience feature and cannot submit this document."
  //         );
  //       }

  //       const result = await dispatch(SaveQuestionPaperThunk());
  //       if (SaveQuestionPaperThunk.fulfilled.match(result)) {
  //        const paperType = result.payload.body.type;

  //   // Reset editor
  //   dispatch(resetData());

  //   if (paperType === 1) {
  //     // Question Paper
  //     goToStepByTarget(".my-question-view-step", () => {
  // navigate("/qstnPapers", { state: { resetData: true } });});

  //   } else {
  //     // Worksheet
  //     goToStepByTarget(".my-question-view-step" ,()=>
  //     {
  //       navigate("/workSheets", { state: { resetData: true } });
  //     });

  //   }
  //     }

  //     if (type === 2) {
  //       if (userData.admin_id === 104) {
  //         return alert(
  //           "You are currently using the demo experience feature and cannot edit this document."
  //         );
  //       }

  //       dispatch(handleSelectedTab(2));
  //       dispatch(handleEditorContent(content + `<p><br></p>`));
  //     }

  //     if (type === 3) {
  //       if (viewType === 1) {
  //         return navigate(-1);
  //       }
  //       dispatch(handleStage(2));
  //       dispatch(handleSelectedTab(1));
  //       dispatch(handleSubmit(false));
  //     }

  //     if (type === 4) {
  //       dispatch(handleSelectedTab(1));
  //     }
  //   }
  // };
  const handleSubmitbtn = async (type) => {
    console.log("handleSubmitbtn type:", type);
    if (isDemoUser) return blockDemoUser();
    if (type === 1) {
      if (userData.admin_id === 104) {
        return alert(
          "You are currently using the demo experience feature and cannot submit this document.",
        );
      }

      const result = await dispatch(SaveQuestionPaperThunk());
      if (SaveQuestionPaperThunk.fulfilled.match(result)) {
        const paperType = result.payload.body.type;

        // Reset editor
        dispatch(resetData());

        if (paperType === 1) {
          // Question Paper
          goToStepByTarget(".my-question-view-step", () => {
            navigate("/qstnPapers", { state: { resetData: true } });
          });
        } else {
          // Worksheet
          goToStepByTarget(".my-question-view-step", () => {
            navigate("/workSheets", { state: { resetData: true } });
          });
        }
      }
    }
    if (type === 2) {
      if (userData.admin_id === 104) {
        return alert(
          "You are currently using the demo experience feature and cannot edit this document.",
        );
      }

      dispatch(handleSelectedTab(2));
      dispatch(handleEditorContent(content + `<p><br></p>`));
    }

    if (type === 3) {
      if (viewType === 1) {
        return navigate(-1);
      }
      dispatch(handleStage(2));
      dispatch(handleSelectedTab(1));
      dispatch(handleSubmit(false));
    }

    if (type === 4) {
      dispatch(handleSelectedTab(1));
    }
  };
  const downloadPDF = async () => {
    if (isDemoUser) return blockDemoUser();
    if (userData.roles === "trial") {
      return alert("Trial users cannot download");
    }

    const html = contentToPrintRef.current.innerHTML;
    dispatch(downloadPDFThunk(html));
  };
  const resizeImagesForDOC = () => {
    if (isDemoUser) return blockDemoUser();
    const container = contentToPrintRef.current;
    if (!container) return;

    const imgs = container.querySelectorAll("img");

    imgs.forEach((img) => {
      const width = 300; // your required size
      const height = (img.naturalHeight / img.naturalWidth) * width;

      // Wrap image in VML-compatible HTML (Word understands this format)
      const vml = `
      <span style="display:inline-block;width:${width}px;height:${height}px;">
        <img src="${img.src}" width="${width}" height="${height}" style="object-fit:contain;" />
      </span>
    `;

      img.outerHTML = vml;
    });
  };

  const downloadDOC = async () => {
    if (isDemoUser) return blockDemoUser();
    if (userData.roles === "trial") {
      return alert("Trial users cannot download");
    }

    resizeImagesForDOC();

    const html = contentToPrintRef.current.innerHTML;

    const header = `
    <html xmlns:v="urn:schemas-microsoft-com:vml"
          xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:w="urn:schemas-microsoft-com:office:word"
          xmlns:m="http://schemas.microsoft.com/office/2004/12/omml"
          xmlns="http://www.w3.org/TR/REC-html40">
    <head><meta charset="utf-8"></head><body>
  `;

    const footer = `</body></html>`;

    const finalDoc = header + html + footer;

    const blob = new Blob([finalDoc], {
      type: "application/msword",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "question-paper.doc";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      {/* <h4>Question Paper Preview</h4> */}

      <div className=" mb-3 px-2 w-100 ">
        <div className="d-flex gap-3">
          {selectedTab === 1 && viewType !== 1 && (
            <button
              className="btn btn-primary btn-sm confirm-button-step"
              onClick={(e) => {
                e.preventDefault();
                handleSubmitbtn(1);
              }}
            >
              Confirm
            </button>
          )}

          {selectedTab === 1 && (
            <button
              className="btn btn-primary btn-sm"
              onClick={(e) => {
                e.preventDefault();
                handleSubmitbtn(2);
              }}
            >
              Edit
            </button>
          )}

          {selectedTab === 1 && (
            <ReactToPrint
              trigger={() => (
                <button className="btn btn-primary btn-sm print-button-step">
                  Print
                </button>
              )}
              content={() => {
                if (isDemoUser) {
                  blockDemoUser();
                  return null;
                }
                if (userData.roles === "trial") {
                  return alert(
                    "You are currently in a trial period and cannot print this document.",
                  );
                }
                return contentToPrintRef.current;
              }}
            />
          )}

          {selectedTab === 2 && (
            <button
              className="btn btn-primary btn-sm"
              onClick={(e) => {
                e.preventDefault();
                handleSubmitbtn(4);
              }}
            >
              View Preview
            </button>
          )}
          {selectedTab === 2 && (
            <ReactToPrint
              trigger={() => (
                <button className="btn btn-primary btn-sm">Print</button>
              )}
              content={() => {
                if (userData.roles === "trial") {
                  return alert(
                    "You are currently in a trial period and cannot print this document.",
                  );
                }
                return editorcontentToPrintRef.current;
              }}
            />
          )}

          {selectedTab === 1 && (
            <div className="dropdown download-button-step" ref={dropdownRef}>
              <button
                className="btn btn-primary btn-sm dropdown-toggle px-3 py-2 "
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ fontSize: "14px", fontWeight: 500 }}
              >
                Download
              </button>

              <ul
                className="dropdown-menu shadow-sm rounded-3"
                style={{ minWidth: "180px", fontSize: "14px" }}
              >
                <li>
                  <button
                    className="dropdown-item py-2"
                    onClick={downloadPDF}
                    style={{ fontSize: "14px" }}
                  >
                    Download as PDF
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item py-2"
                    onClick={downloadDOC}
                    style={{ fontSize: "14px" }}
                  >
                    Download as DOC
                  </button>
                </li>
              </ul>
            </div>
          )}

          <button
            className="btn btn-primary btn-sm"
            onClick={(e) => {
              e.preventDefault();
              handleSubmitbtn(3);
            }}
          >
            Go Back
          </button>
        </div>
      </div>
      {showPopup && (
        <Popup
          title="Complete Your Details"
          minHeight="400px"
          maxWidth="500px"
          onClose={() => {
            setShowPopup(false);
            navigate("/registration");
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <div style={{ marginBottom: "24px" }}>
              <p>To get the final output of your work or to Print / Download</p>
              <br />
              <p>Complete the registration process with your Name Details.</p>
            </div>

            <button
              onClick={() => navigate("/registration")}
              style={{
                padding: "12px 24px",
                borderRadius: "8px",
                color: "white",
                fontWeight: "600",
                backgroundImage:
                  "linear-gradient(to right, #3b82f6, #a855f7, #ec4899)",
                boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                border: "none",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.filter = "brightness(1.15)";
              }}
              onMouseLeave={(e) => {
                e.target.style.filter = "brightness(1)";
              }}
              onMouseDown={(e) => {
                e.target.style.transform = "scale(0.95)";
              }}
              onMouseUp={(e) => {
                e.target.style.transform = "scale(1)";
              }}
            >
              Proceed
            </button>
          </motion.div>
        </Popup>
      )}

      <div className="d-flex justify-content-center align-items-center">
        {selectedTab === 1 && (
          <div className={`content-stage-3 ${selectLoader(loader)}`}>
            <div
              dangerouslySetInnerHTML={{ __html: content }}
              ref={contentToPrintRef}
            />
          </div>
        )}
        {selectedTab === 2 && <TinyEditor />}

        <div style={{ display: "none" }}>
          <div
            dangerouslySetInnerHTML={{ __html: editorContent }}
            ref={editorcontentToPrintRef}
          />
        </div>
      </div>
    </div>
  );
}

export default Confirmation;
